import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const fetchTransferEmployeeData = async (data: any) => {
	try {
		const URL = `${API_URL}TransferEmployeeDetails`;
		console.log('API URL:', URL);
		console.log('Request params:', data);
		const requestData = {
			fetchTransferEmployeeToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		console.error('Error in fetchTransferEmployeeData:', error);
		throw error;
	}
};

export const fetchAllTransfersData = async (data: any) => {
	try {
		const URL = `${API_URL}GetAllEmployeeTransfers`;
		console.log('Get All Transfers API URL:', URL);
		console.log('Request params:', data);
		const requestData = {
			fetchAllTransfersToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		console.error('Error in fetchAllTransfersData:', error);
		throw error;
	}
};

export const deleteTransferData = async (data: any) => {
	try {
		const URL = `${API_URL}DeleteTransferEmployee`;
		console.log('Delete Transfer API URL:', URL);
		console.log('Request params:', data);
		const requestData = {
			deleteTransferToken: data,
		};
		return makeApiCall(URL, requestData);
	} catch (error) {
		console.error('Error in deleteTransferData:', error);
		throw error;
	}
};
